export var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["Error"] = 0] = "Error";
    NotificationType[NotificationType["Message"] = 1] = "Message";
})(NotificationType || (NotificationType = {}));
